/* tslint:disable */
import { NgModule, ModuleWithProviders, InjectionToken } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ObjectObjectConfiguration, ObjectObjectConfigurationInterface } from './object-object-configuration';

export const BASE_PATH = new InjectionToken<string>('basePath');

import { MemberService } from './services/member.service';
import { ContactService } from './services/contact.service';
import { ApiService } from './services/api.service';
import { NewsService } from './services/news.service';
import { FaqService } from './services/faq.service';
import { PageService } from './services/page.service';
import { GalleryService } from './services/gallery.service';
import { SettingService } from './services/setting.service';
import { StatisticsService } from './services/statistics.service';
import { AddressService } from './services/address.service';
import { CountryService } from './services/country.service';
import { CollaboratorService } from './services/collaborator.service';
import { LanguageService } from './services/language.service';
import { PaymentService } from './services/payment.service';

/**
 * Provider for all [object Object] services, plus ObjectObjectConfiguration
 */
@NgModule({
  imports: [
    HttpClientModule
  ],
  exports: [
    HttpClientModule
  ],
  declarations: [],
  providers: [
    ObjectObjectConfiguration,
    MemberService,
    ContactService,
    ApiService,
    NewsService,
    FaqService,
    PageService,
    GalleryService,
    SettingService,
    StatisticsService,
    AddressService,
    CountryService,
    CollaboratorService,
    LanguageService,
    PaymentService
  ],
})
export class ObjectObjectModule {
  static forRoot(customParams: ObjectObjectConfigurationInterface): ModuleWithProviders<ObjectObjectModule> {
    return {
      ngModule: ObjectObjectModule,
      providers: [
        {
          provide: ObjectObjectConfiguration,
          useValue: {rootUrl: customParams.rootUrl}
        }
      ]
    }
  }
}
